import { Stack, styled } from "@mui/material";
import { toPx } from "../MuiHelpers/helpers";
import { MuiImage } from "../MuiImage";

const CONTAINER_MAX_WIDTH_PX = 700;
const IMAGE_WIDTH_PX = 210;

export const ContainerStack = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        maxWidth: toPx(CONTAINER_MAX_WIDTH_PX),
        pt: theme.spacing(6),
        mx: "auto",
        textAlign: "center",
        gap: theme.spacing(4),
    }),
);

export const AmlImage = styled(MuiImage)(({ theme }) =>
    theme.unstable_sx({
        width: toPx(IMAGE_WIDTH_PX),
        mx: "auto",
    }),
);
